import { render, staticRenderFns } from "./BrandLogoCarousel.vue?vue&type=template&id=466c2428&"
import script from "./BrandLogoCarousel.vue?vue&type=script&lang=js&"
export * from "./BrandLogoCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports